import { getStoredTestModules } from "../../../../utlis/helpers";
import { userInfoFetch } from "../../../../utlis/commonFunction";
import {
  getMeasurementModule,
  isStsEligible,
  STS_MODULE_ID,
} from "../../../../utlis/measurementModules";

export const getStsContext = () => {
  let person;
  try {
    person = userInfoFetch();
  } catch {
    return null;
  }
  const params = new URLSearchParams(window.location.search);
  const requestedPeople = [
    params.get("seniorId"),
    params.get("seniorUuid"),
  ].filter(Boolean);
  const cacheOwner = sessionStorage.getItem("measurementModulesPersonId");
  const storedModules =
    cacheOwner && cacheOwner !== String(person?.id)
      ? []
      : getStoredTestModules();
  const serverModule = storedModules.find(
    (item) => Number(item.moduleId) === STS_MODULE_ID,
  );
  if (
    !isStsEligible() ||
    !person?.id ||
    requestedPeople.some((requested) => requested !== String(person.id)) ||
    serverModule?.isOperationAllowed === false
  )
    return null;
  return {
    person: { ...person },
    moduleInfo: {
      ...getMeasurementModule(STS_MODULE_ID),
      ...serverModule,
      moduleId: STS_MODULE_ID,
    },
  };
};
